<script setup lang="ts">
interface Props {
  text: string
  tagline?: string | null
  type?: 'title' | 'subtitle'
  iconClass?: string | null
  noWrap?: boolean
  padding?: 'large' | 'small'
}

const props = withDefaults(defineProps<Props>(), {
  type: 'title',
  padding: 'small',
  tagline: null,
  iconClass: null,
})

const dinamicClasses = {
  'text-2xl md:text-3xl lg:text-4xl': props.type === 'title',
  'text-lg md:text-xl lg:text-2xl': props.type === 'subtitle',
  'flex items-center gap-2': !!props.iconClass,
  'py-5': props.padding === 'large',
  'py-1': props.padding === 'small',
}
</script>

<template>
  <div
    :class="dinamicClasses"
    class="leading-tight title-component"
  >
    <span
      v-if="iconClass"
      class="flex aspect-square items-center justify-center rounded-lg bg-primary p-2 title-icon-container"
    >
      <span
        class="text-lg lg:text-xl text-white leading-noner"
        :class="iconClass"
      />
    </span>
    <span
      class="font-bold title-text leading-none"
      :class="noWrap ? 'text-nowrap' : ''"
    >
      {{ text }}
    </span>
    <span
      v-if="tagline"
      class="ml-3 font-normal title-text"
      :class="noWrap ? 'text-nowrap' : ''"
    >
      {{ tagline }}
    </span>
  </div>
</template>
